const getters = {
  // layout
  sidebar: state => state.app.sidebar,
  sidebarCollapsed: state => !state.app.sidebar.opened,

  // app
  size: state => state.app.size,
  device: state => state.app.device,

  // tags
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,

  // auth/user
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  isMainAdmin: state => state.user.profile && state.user.profile.adminLevel === 1,
  userInfo: state => {
    const p = state.user.profile || {}
    return {
      id: p.id,
      username: p.username || '',
      nickname: p.realName || p.username || '',
      adminLevel: p.adminLevel != null ? p.adminLevel : 0,
      avatar: state.user.avatar
    }
  },

  // permission
  permission_routes: state => state.permission.routes
}
export default getters
